import React from 'react';

import { Alert } from '@openedx/paragon';

import { useT } from '../context/LanguageContext';

const ResetPasswordSuccess = () => {
  const { t } = useT();

  return (
    <Alert id="reset-password-success" variant="success" className="mb-5">
      <Alert.Heading>
        {t('reset.password.success.heading')}
      </Alert.Heading>
      <p>{t('reset.password.success')}</p>
    </Alert>
  );
};

export default ResetPasswordSuccess;
